import fa_lei from "./fa_lei.json";
import fa_bir from "./fa_bir.json";

const headers = {
  fa_lei,
  fa_bir,
};

export function getHeaderPageData() {
  return headers[`${CONFIG.league}_${CONFIG.tricode}`];
}
